import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const logInApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    signIn: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/signin',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response, // Transform response if needed
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
